import { useEffect, useState } from "react";
import { OptionType } from "./AttributePicker";
import { UOM, fetchUoms } from "../../../api";
import Select from "react-select";
import CustomModal from "../../widgets/components/CustomModal";
import { UOMForm } from "../../misc_objects/UoMForm";

interface UomPickerProps {
    tabIndex?: number;
    onUomChange: (uomId: string) => void;
    selectedUom?: string;
  }
  
  export function UomPicker({
    tabIndex,
    onUomChange,
    selectedUom,
  }: UomPickerProps) {
    const [uoms, setUoms] = useState<OptionType[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState<OptionType | null>(null);
  
    useEffect(() => {
      const getCategories = async () => {
        try {
          const fetchedUoms: UOM[] = await fetchUoms()
          const options = fetchedUoms.map(uom => ({
            value: uom.uomId,
            label: `${uom.uomNm}${uom.uomTxt ? ` - ${uom.uomTxt}` : ''}`,
            color: uom.uomTxt,
          }));
          setUoms(options);
  
          // Set the default selected uom if provided
          if (selectedUom) {
            const defaultOption = options.find(option => option.value === selectedUom) || null;
            if(defaultOption){
              setSelectedOption(defaultOption);
            }
          }
        } catch (error) {
          console.error(`Error fetching UOMs:`, error);
        }
      };
  
      getCategories();
    }, [selectedUom]);
  
    const customStyles = {
      option: (provided: any, { data }: any) => ({
        ...provided,
        display: 'flex',
        alignItems: 'center',
      }),
      singleValue: (provided: any, { data }: any) => ({
        ...provided,
        display: 'flex',
        alignItems: 'center',
      }),
    };
  
    const formatOptionLabel = ({ label, color }: OptionType) => (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {label}
      </div>
    );
  
    const handleSelectChange = (selectedOption: OptionType | null) => {
      if (selectedOption && selectedOption.value === 'add_new') {
        setIsModalOpen(true);
      } else {
        setSelectedOption(selectedOption);
        onUomChange(selectedOption?.value || '');
      }
    };
  
    const handleModalClose = () => {
      setIsModalOpen(false);
    };
    
    const handleAddNew = (newOption: UOM) => {
      const newUomOption = {
        value: newOption.uomId,
        label: newOption.uomNm,
      };
      setIsModalOpen(false);
      setUoms(prevUoms => [...prevUoms, newUomOption]);
      setSelectedOption(newUomOption);
      onUomChange(newUomOption.value);
    };
  
    const modifiedOptions = [
      { value: 'add_new', label: 'Add New'.toTranslatedDisplay(), color: '' },
      ...uoms,
    ];
  
    return (
      <div className="searchable-picker">
        <Select
          className="react-select-styled react-select"
          classNamePrefix="react-select"
          options={modifiedOptions}
          formatOptionLabel={formatOptionLabel}
          styles={customStyles}
          placeholder={`Select Unit of Measure`}
          value={selectedOption}
          onChange={handleSelectChange}
          tabIndex={tabIndex}
          isClearable
        />
        <CustomModal
          title={'Add New Uom'.toTranslatedDisplay()}
          isVisible={isModalOpen}
          onClose={handleModalClose}
          body={<UOMForm onAddNew={handleAddNew} />}
          id={''}
          size="small"
          onSave={() => {}}
        />
      </div>
    );
  }